import { Emitter } from "pixi-particles";
import { configParticlesBoostedField } from "../features/animation/particles/configParticlesBoostedField";
import { utilAnimation } from "../utils/animation/utilAnimation";
var BF2BoostedFieldAnimation = /** @class */ (function () {
    function BF2BoostedFieldAnimation() {
        var _this = this;
        this.particleImage = PIXI.Texture.fromImage(require("../assets/particles/boost.png"));
        this.configForBuilding = configParticlesBoostedField;
        this.particleContainer = new PIXI.Container();
        this.animationStarted = false;
        this.startAnimation = function (container, forceAnimation) {
            if (forceAnimation === void 0) { forceAnimation = false; }
            if (_this.animationStarted) {
                return;
            }
            _this.container = container;
            _this.particleContainer.position.set(-65, -180);
            _this.animationStarted = true;
            _this.emitter = new Emitter(_this.particleContainer, _this.particleImage, _this.configForBuilding);
            _this.container.addChild(_this.particleContainer);
            _this.emitterId = utilAnimation.startParticleAnimation(_this.emitter, false, forceAnimation);
        };
        this.removeAnimation = function () {
            _this.animationStarted = false;
            if (_this.emitter !== undefined) {
                utilAnimation.destroyParticleAnimation(_this.emitter, _this.emitterId);
            }
            _this.container.removeChild(_this.particleContainer);
        };
    }
    return BF2BoostedFieldAnimation;
}());
export { BF2BoostedFieldAnimation };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/BF2BoostedFieldAnimation.ts
// module id = 2188
// module chunks = 3